<template>
    <div class="memberedit">
        <div class="area">
            <p class="title">发票信息管理</p>
            <div>
                <el-form label-position="left" status-icon ref="ruleForm" label-width="170px" class="demo-ruleForm">
                    <el-form-item label="公司名称(必填)" prop="company_name" size="mini">
                        <el-input type="text" v-model="company_name" autocomplete="off" placeholder="请输入公司名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号(必填)" prop="duty_paragraph" size="mini">
                        <el-input type="text" v-model="duty_paragraph" autocomplete="off" placeholder="请输入公司的税号">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="地址及电话" prop="site_phone" size="mini">
                        <el-input type="text" v-model="site_phone" autocomplete="off" placeholder="请输入公司的地址及电话">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="开户行及账号" prop="bank" size="mini">
                        <el-input type="text" autocomplete="off" placeholder="请输入公司开户行及账号" v-model="bank"></el-input>
                    </el-form-item>
                    <el-form-item label="下载电子发票邮箱(必填)" prop="email" size="mini">
                        <el-input type="text" autocomplete="off" placeholder="请输入接收电子发票的邮箱" v-model="email"></el-input>
                    </el-form-item>
                    <el-form-item label="邮寄发票-收件人(必填)" prop="name" size="mini">
                        <el-input type="text" autocomplete="off" placeholder="请输入纸质发票收件人名称" v-model="name"></el-input>
                    </el-form-item>
                    <el-form-item label="邮寄发票-地址(必填)" prop="address" size="mini">
                        <el-input type="text" autocomplete="off" placeholder="请输入纸质发票收件人地址" v-model="address">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="邮寄发票-电话(必填)" prop="phone" size="mini">
                        <el-input type="text" autocomplete="off" placeholder="请输入纸质发票收件人电话" v-model="phone"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span class="btn" @click="clear_basic_information">重置</span>
                        <span class="btn" @click="save_invoice">
                            <i v-if="status">保存/修改</i>
                            <i class="el-icon-loading lod" v-else></i>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
            <p class="title">注意：请认真填写上面所有信息，保证信息真实有效，如填写信息有误造成一切损失自行承担。发送电子发票或者纸质发票是根据实际情况而定！</p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                company_name: "",
                duty_paragraph: "",
                site_phone: "",
                bank: "",
                email: "",
                name: "",
                address: "",
                phone: "",
                if_data: true,
                status: true,
            }
        },
        created() {
            this.request_invoice()
        },
        methods: {
            // 清空全部的填写信息
            clear_basic_information() {
                this.company_name = "";
                this.duty_paragraph = "";
                this.site_phone = "";
                this.bank = "";
                this.email = "";
                this.name = "";
                this.address = "";
                this.phone = "";
            },

            // 请求用户的发票信息
            request_invoice() {
                this.$http.getInvoiceData().then(response => {
                    if (response.code == 200) {
                        this.if_data = false
                        this.company_name = response.data.company;
                        this.duty_paragraph = response.data.code;
                        this.site_phone = response.data.addr_tel;
                        this.bank = response.data.acount;
                        this.email = response.data.receive_email;
                        this.name = response.data.receive_user;
                        this.address = response.data.receive_addr;
                        this.phone = response.data.receive_phone;
                    } else {
                        this.if_data = true
                    }
                }).catch(err => {
                    this.$message({
                        message: '网络出错',
                        type: 'error',
                        customClass: 'hint-message',
                        center: true
                    });
                });
            },

            // 是否确认跳转到开票界面
            transforms () {
                this.$confirm('点击"确定"跳转到申请页面', '发票信息保存成功, 是否马上申请发票?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
                }).then(() => {
                    this.$emit('switchover', "pay_record")
                }).catch(() => {});
            },

            // 保存用户的发票信息
            save_invoice() {
                if (!this.company_name || !this.duty_paragraph || !this.email || !this.name || !this.address || !this.phone) {
                    this.$message({
                        message: "信息填写不完整",
                        type: 'warning',
                        customClass: 'hint-message',
                        center: true
                    });
                    return
                }
                this.status = false
                let param = new URLSearchParams();
                if (this.if_data) {
                    param.append("flag", "create");
                }
                param.append("company", this.company_name);
                param.append("code", this.duty_paragraph);
                param.append("addr_tel", this.site_phone);
                param.append("acount", this.bank);
                param.append("receive_email", this.email);
                param.append("receive_user", this.name);
                param.append("receive_addr", this.address);
                param.append("receive_phone", this.phone);
                this.$http.postSaveInvoice(param).then(response => {
                    if (response.code == 200) {
                        // this.$message({
                        //     message: '发票信息保存成功',
                        //     type: 'success',
                        //     customClass: 'hint-message',
                        //     center: true
                        // });
                        this.transforms();
                    } else {
                        this.$message({
                            message: response.msg,
                            type: 'warning',
                            customClass: 'hint-message',
                            center: true
                        });
                    }
                    this.status = true
                }).catch(err => {
                    this.$message({
                        message: '网络出错',
                        type: 'error',
                        customClass: 'hint-message',
                        center: true
                    });
                    this.status = true
                });
            }
        }
    }
</script>
<style scoped>
    .memberedit {
        width: 550px;
        /* margin-left: 50px; */
    }

    .area {
        margin-top: 15px;
    }

    .title {
        color: red;
        font-size: 16px;
    }

    .demo-ruleForm {
        padding-top: 20px;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        color: white;
        border: 0;
        background-color: #A7231E;
        font-weight: bold;
        padding: 5px 10px;
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
        background-color: rgb(207, 50, 44);
    }
    .lod {
        display: inline-block;
        text-align: center;
        width: 56px;
    }
</style>